<template>
  <div>
    <hi-cell title="审厂评价得分：" :value="conclusionResultList.checkResultScore"></hi-cell>
    <hi-cell
      title="审核是否通过："
      :value="conclusionResultList.checkResultDict"
      :options="checkResultDictOptions"
    ></hi-cell>
    <hi-cell title="合格是否整改：" :value="conclusionResultList.isChange" :options="isChangeOptions"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'ConclusionResult',
  components: {},
  data() {
    return {}
  },
  props: {
    conclusionResultList: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    checkResultDictOptions() {
      return this.$store.getters.dicts.yes_no
    },
    isChangeOptions() {
      return this.$store.getters.dicts.yes_no
    }
  }
}
</script>
